/*
* Created on Jan 12, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

import React, { useContext, useState } from "react";

const OrganizationContext = React.createContext(null)
const OrganizationUpdateContext = React.createContext(null)
const OrganizationListRefreshContext = React.createContext(null)

export const useOrganization = () => {
    return useContext(OrganizationContext);
}
export const useOrganizationUpdate = () => {
    return useContext(OrganizationUpdateContext);
}

export const useOrganizationListRefresh = () => {
    return useContext(OrganizationListRefreshContext);
}

export const OrganizationListRefreshProvider = ({children}) => {
    const [refresh, setRefresh] = useState(0);

    return (
        <OrganizationListRefreshContext.Provider value={{refresh, setRefresh}}>
            {children}
        </OrganizationListRefreshContext.Provider>
    )
}

export const OrganizationProvider = ({children}) => {
    const currentOrg = window.localStorage.getItem('currentOrg')
    const [org, setOrg] = useState(currentOrg ? JSON.parse(currentOrg) : null);

    const getCurrentOrg = () => {
        const pathname = window.location.pathname;
        const path = pathname.split('/');
        const org_id = path?.[1] || '';
        if (!org_id) {
            return null;
        }
        const currentOrg = window.localStorage.getItem('currentOrg')
        const _org = currentOrg ? JSON.parse(currentOrg) : null;
        if (_org && _org.organization_id !== org_id) {
            window.localStorage.removeItem('currentOrg');
            return null;
        }
        // setOrg(_org);
        return _org;
    }

    const setCurrentOrg = (org) => {
        setOrg(org);
        window.localStorage.setItem('currentOrg', JSON.stringify(org));
    }

    const userProfile = () => {
        const organization = getCurrentOrg();
        if (!organization) {
            return {
                userStatus: {}, oldest: null, is_owner: false,
                permissions: null, role: 'member', hasDevicePermission: false,
            };
        }

        // Prefer the dashboard-trimmed payload's baked-in current_user.
        // The welcome-page dashboard sets currentOrg with this shape.
        if (organization.current_user) {
            const cu = organization.current_user;
            const devicePerm = cu.permissions?.manage_device;
            const hasDevicePermission = devicePerm
                ? ((devicePerm.user_assigned?.length || 0)
                   + Object.values(devicePerm.fixed || {}).flat().length) > 0
                : false;
            return {
                userStatus: organization.user_counts || {},
                oldest: organization.oldest_owner || null,
                is_owner: cu.is_owner === true,
                permissions: cu.permissions || null,
                role: cu.role || 'member',
                hasDevicePermission,
            };
        }

        // Fallback: per-org pages overwrite currentOrg via the old
        // /organization/<id> endpoint which returns users[] but no
        // current_user. Derive the same shape from users[] so navigating
        // between sub-pages doesn't drop role/permissions.
        const currentUser = JSON.parse(window.localStorage.getItem('currentUser') || 'null');
        const status = {};
        let oldest = null;
        let is_owner = false;
        let permissions = null;
        let role = 'member';
        let hasDevicePermission = false;
        const users = organization.users || [];
        for (const user of users) {
            status[user.status] = (status[user.status] || 0) + 1;
            if (user.is_owner === true || user?.role === 'owner') {
                if (!oldest || Date.parse(user.created_at) < Date.parse(oldest.created_at)) {
                    oldest = user;
                }
            }
            if (user.id === currentUser?.user_id) {
                permissions = user.permissions;
                role = user.role || user?.permissions?.role || (user.is_owner ? 'owner' : 'member');
                if (user.is_owner || user?.role === 'owner') {
                    is_owner = true;
                }
                const devicePerm = user.permissions?.manage_device;
                if (devicePerm) {
                    const userAssigned = devicePerm.user_assigned || [];
                    const fixed = Object.values(devicePerm.fixed || {}).flat();
                    hasDevicePermission = (userAssigned.length + fixed.length) > 0;
                }
            }
        }
        if (oldest?.avatars) {
            oldest = {...oldest, has_avatar: true};
        }
        return {userStatus: status, oldest, is_owner, permissions, role, hasDevicePermission};
    };

    return (
        <OrganizationContext.Provider value={{getCurrentOrg, setCurrentOrg, userProfile}}>
            {/*<OrganizationUpdateContext.Provider value={setOrg}>*/}
            <OrganizationListRefreshProvider>
                {children}
            </OrganizationListRefreshProvider>
            {/*</OrganizationUpdateContext.Provider>*/}
        </OrganizationContext.Provider>
    )
}